import { View3dGlobal, webcadDefines, WebCadItemManager, isMat, ItemType, ThreeView, w3dItemInfo, WebCadRenderer } from "../index";
import { SceneExtrasMaterial } from "../sceneExtrasMaterial";
import * as marietta from "../../..";
import { defines, geoUtils, matUtils } from "../../base";
import { Material } from './Material'

export class LeftMenuChangeColor {

    constructor() {

    }

    /* changeColor
     * マテリアルを変更する.
     */
    public changeColor(type: ItemType, index: number, floor?: number): void {
        const model = ThreeView.get().planmgr.autoData.Model;
        const matmgr = ThreeView.get().matmgr;
        const materialSet = matmgr._partsMaterials;
        switch (type) {
            case ItemType.Entry:
                // Conditional : all doors are to have the same material.
                this.changeMaterialUnified(matmgr._entryDoorMaterial, materialSet.entDoors, index);
                model.Ent.SetMaterialName('body', materialSet.entDoors[index].name);

                //pixelstreaming対応
                this.changePrefs('ent-body', materialSet.entDoors[index].name);
                break;
            case ItemType.Door:
                // Conditional : all doors are to have the same material.
                this.changeMaterialUnified(matmgr._doorMaterial, materialSet.doorMaterials, index);
                model.Door.SetMaterialName('body', materialSet.doorMaterials[index].name);

                //pixelstreaming対応
                this.changePrefs('door-body', materialSet.doorMaterials[index].name);
                break;
            case ItemType.Sash:
                // Conditional : all doors are to have the same material.
                this.changeMaterialUnified(matmgr._windowMaterial, materialSet.windowMaterials, index);
                model.Sash.SetMaterialName('body', materialSet.windowMaterials[index].name);

                //pixelstreaming対応
                this.changePrefs('sash-body', materialSet.windowMaterials[index].name);
                break;
            case ItemType.Garage:
                // Conditional : all doors are to have the same material.
                this.changeMaterialUnified(matmgr._garageMaterial, materialSet.garageMaterials, index);
                model.Shutter.SetMaterialName('body', materialSet.garageMaterials[index].name);

                //pixelstreaming対応
                this.changePrefs('shutter-body', materialSet.windowMaterials[index].name);                
                break;
            case ItemType.Curtain:
                // Conditional : all doors are to have the same material.
                this.changeMaterialUnified(matmgr._curtainMaterial, materialSet.curtainMaterials, index);
                model.Sash.SetMaterialName('curtain', materialSet.curtainMaterials[index].name);
                break;
            // 床・階段.
            case ItemType.Floor:
                // Conditional : all doors are to have the same material.
                const floorTexture = materialSet.floorTexes[index];
                this.changeMapUnified(matmgr._floorMaterial, floorTexture);
                const stairIndex = matmgr.findTexIndex(materialSet.stairTexes, floorTexture.name + "_STAIR");
                this.changeMapUnified(matmgr._stairMaterial, materialSet.stairTexes[stairIndex]);
                model.SetMaterialName("interior", "floor", floorTexture.name);

                //pixelstreaming対応
                this.changeMaterial(matmgr._floorMaterial, floorTexture.name);    // 床
                this.changePrefs('interior-floor', floorTexture.name);          // 床
                this.changeMaterial(matmgr._stairMaterial, materialSet.stairTexes[stairIndex].name);    // 階段
                break;
            // 内壁.
            case ItemType.Cloth:
                // Conditional : all doors are to have the same material.
                const cloth = materialSet.clothTexes[index];
                this.changeMapUnified(matmgr._inWallMaterial, cloth);
                this.changeMapUnified(matmgr._ceilingMaterial, cloth);
                this.changeMapUnified(matmgr._sagariMaterial, cloth);
                model.SetMaterialName("interior", "wall", cloth.name);
                model.SetMaterialName("interior", "kosi", cloth.name);
                model.SetMaterialName("interior", "ceiling", cloth.name);

                //pixelstreaming対応
                this.changeMaterial(matmgr._inWallMaterial, cloth.name);
                this.changeMaterial(matmgr._ceilingMaterial, cloth.name);
                this.changeMaterial(matmgr._sagariMaterial, cloth.name);
                this.changePrefs('interior-wall', cloth.name);
                this.changePrefs('interior-kosi', cloth.name);
                this.changePrefs('interior-ceiling', cloth.name);
                break;
            // 屋根、端、棟.
            case ItemType.Roof:
                const roofTexture = materialSet.roofTexes[index];

                const hanaIndex = this.findMatIndex(materialSet.hanaMaterials, roofTexture.name + "_HANA");
                const muneIndex = this.findMatIndex(materialSet.muneMaterials, roofTexture.name + "_MUNE");

                const hanaTExture = materialSet.hanaMaterials[hanaIndex];
                const muneTexture = materialSet.muneMaterials[muneIndex];

                this.changeMaterialUnified(matmgr._hanaMaterial, materialSet.hanaMaterials, hanaIndex);
                this.changeMaterialUnified(matmgr._muneMaterial, materialSet.muneMaterials, muneIndex);
                for (let floor = 1; floor <= webcadDefines.Limits.maxFloor; floor++) {
                    this.changeMapUnified(matmgr._roofMaterial[floor], roofTexture);
                    this.setOutMatChange("roof", roofTexture.name, floor);
                    this.setOutMatChange("hana", materialSet.hanaMaterials[hanaIndex].name, floor);
                    this.setOutMatChange("mune", materialSet.muneMaterials[muneIndex].name, floor);

                    //pixelstreaming対応
                    this.changeMaterial(matmgr._roofMaterial[floor], roofTexture.name);
                }
                //pixelstreaming対応

                this.changeMaterial(matmgr._hanaMaterial, hanaTExture.name);
                this.changeMaterial(matmgr._muneMaterial, muneTexture.name);
                break;
            // 外壁.
            case ItemType.Wall:
                const wallTexture = materialSet.wallTexes[index];
                this.changeMapUnified(matmgr._wallMaterials[floor], wallTexture);
                this.setOutMatChange("wall", wallTexture.name, floor);

                //pixelstreaming対応
                this.changeMaterial(matmgr._wallMaterials[floor], wallTexture.name);
                break;
            // 外壁腰.
            case ItemType.WallKosi:
                const wallKosiTexture = materialSet.wallKosiTexes[index];
                this.changeMapUnified(matmgr._wallKosiMaterials[floor], wallKosiTexture);
                this.setOutMatChange("kosi", wallKosiTexture.name, floor);
                this.setOutMatChange("balcony", wallKosiTexture.name, floor);

                //pixelstreaming対応
                this.changeMaterial(matmgr._wallKosiMaterials[floor], wallKosiTexture.name);
                this.changePrefs(`out0${floor}-balcony`, wallKosiTexture.name); // out02-balcony out03-balcony
                break;
            // 巾木.
            case ItemType.Habaki:
                // Conditional : all doors are to have the same material.
                const habakiTexture = materialSet.habakiTexes[index];
                this.changeMapUnified(matmgr._habakiMaterial, habakiTexture);
                model.SetMaterialName("interior", "habaki", habakiTexture.name);

                //pixelstreaming対応
                this.changePrefs('interior-habaki', habakiTexture.name);
                break;
        }

        //2D側に変更結果を反映
        let jsonData = model.writeJSON();
        marietta.webcad.WebCADGlobal.setModelParamFromConstructionModel(jsonData);
    }

    /* findMatIndex
     * 名前からマテリアルインデックスを得る.
     */
    private findMatIndex(materials: any[], name: string, def?: number): number {
        if (def == undefined) def = 0;
        for (let i = 0; i < materials.length; i++) {
            if (materials[i].name == name) return i;
        }
        return def;
    }
    
    /* changeMaterial
     * テクスチャマップを変更する.
     */
    private changeMaterialUnified(material: any, mats: Material[], index: number, floor?: number) {
        matUtils.setColor(material, matUtils.getColor(mats[index]));
    }

    /* setTextureChange
     * テクスチャマップの変更を通知する.
     */
    private setOutMatChange(name: string, materialName: string, floor: number) {
        const model = ThreeView.get().planmgr.autoData.Model;
        // eval("model.Out0" + floor ).SetMaterialName(name, mat_name);
        model.getOutMaterial(floor).SetMaterialName(name, materialName);
    }

    /* changeMapUnified
    * テクスチャマップを変更する.
    */
    private changeMapUnified(material: any, texes: THREE.Texture) {
        if ((material == undefined) || (texes == undefined)) return;
        material.map = texes;
    }

    // pixelasreaming連携
    private changeMaterial(material_, textureName: string) {
        if (material_ == null) return;
        // 該当するマテリアルがアサインされているメッシュを取得
        const meshes: THREE.Mesh[] = [];
        ThreeView.get().wcItemmgr.houseObjects.traverse((object) => {
            const mesh = <THREE.Mesh>object;
            if (mesh.isMesh == null) return;

            const materialArray = Array.isArray(mesh.material) ? mesh.material : [mesh.material];

            for (let i = 0; i < materialArray.length; i++) {
                const material = materialArray[i];
                if (material.uuid == material_.uuid) {
                    meshes.push(mesh);
                    break;
                }
            }
        });
        if (meshes.length == 0) return;

        new SceneExtrasMaterial().update(material_.name, textureName);
    }

    private changePrefs(name: string, textureName:string) {
        new SceneExtrasMaterial().update(name, textureName);
    }
}
